import { useEffect, useState } from "react";
import BrazilFlagIcon from "../../../../../../../components/language-selection/icons/brazil-flag-icon";
import SpainFlagIcon from "../../../../../../../components/language-selection/icons/spain-flag-icon";
import UnitedStatesFlagIcon from "../../../../../../../components/language-selection/icons/united-states-flag-icon";
import { Text } from "../../../../../../../components/common";
import {
  Flag,
  LanguageName,
  LanguageOption,
  LanguageSelector,
  RadioButton,
} from "./index.styled";
import { useTranslation } from "react-i18next";
import { LabelContainer } from "../label-input/label-input.styled";
import { useTheme } from "styled-components";

interface LanguageSelectProps {
  label: string;
  language: string;
  onChange: (language: string) => void;
}

export const LanguageSelect: React.FC<LanguageSelectProps> = ({
  label,
  language,
  onChange,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  const locales = ["pt-BR", "en", "es"];
  const { t } = useTranslation();
  const iconMap = new Map<string, JSX.Element>();
  iconMap.set("pt-BR", <BrazilFlagIcon />);
  iconMap.set("en", <UnitedStatesFlagIcon />);
  iconMap.set("es", <SpainFlagIcon />);
  const theme = useTheme();

  useEffect(() => {
    setSelectedLanguage(language);
  }, [language]);

  return (
    <>
      <LabelContainer>
        <Text
          color={theme.colors.primaryBlue.main}
          fontWeight={600}
          fontSize={15}
          margin="0 0 .5rem 0"
        >
          {label}
        </Text>
      </LabelContainer>
      <LanguageSelector>
        {locales.map((locale) => (
          <LanguageOption key={locale}>
            <RadioButton
              name="language"
              value={locale}
              checked={selectedLanguage === locale}
              onChange={() => {
                setSelectedLanguage(locale);
                onChange(locale);
              }}
            />
            <Flag>{iconMap.get(locale)}</Flag>
            <LanguageName>{t(`languages.${locale}`)}</LanguageName>
          </LanguageOption>
        ))}
      </LanguageSelector>
    </>
  );
};
